module.exports = {
    status: "production",
    baseUrl: "https://hamrahi.cloud",
    driveRestAPI: "https://hamrahi.cloud/api",
    chatBaseUrl: "wss://hamrahi.cloud/",
    GA_MEASUREMENT_ID: "G-5JZ2S6WR6D",
    favIconUrl: "https://hamrahi.cloud/drive/hamrahi.svg",
    zarebinUserConfig: "https://hamrahi.cloud/get-header",
    loginBaseUrl: "https://hamrahi.cloud",
    trackerRestAPI: "https://hamrahi.cloud",
    aggregatorBaseUrl: "https://aggregator.hamrahi.cloud/",
    setAggregatorBaseUrl: "https://setaggregator.hamrahi.cloud/",
    fluentdUrl: "https://hamrahi.cloud",
    loginRedirectUrl: "zarebinlite://login",
    splusLoginRedirectUrl: "soroush://lookup?key=SplusCampaign",
    splusDownloadAppUrl: "https://splus.ir/p/download",
    cookieKey: "HAMRAHI_CLOUD_AUTH_TOKEN",
    whiteListTargets: "abrehamrahi.ir,hamrahi.cloud,sthamrahi.ir",
    whiteListGeneralUrl: "hamrahi.cloud,abrehamrahi.ir,zarebin.ir,mohtava.cloud,eshterak.cloud",
    sendXToken: "false",
    chatAPIBaseUrl: "https://hamrahi.cloud/chatapi/",
    zarebinNasle3Url: "https://bw3.zarebin.ir",
    assistant: true,
    initialLoadedFragmentCount: "1",
    filmAndSerialAllowedUsers: JSON.stringify([]),
    keshtAllowedUsers: JSON.stringify([
        {
            user_id: 144633
        }
    ]),
    keshtBasePath: "/niroo",
    keshtAppName: "آموزش",
    filmAndSerialBasePath: "/film-serial",
    hamrahiCloudLanding: "https://hamrahi.cloud/",
    commentPanel: "https://hamrahi.cloud/comments/"
};
